<template>
    <!-- Statistics -->
    <div class="counter" style="background-color:#262431;">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    
                    <!-- Counter -->
                    <div id="counter">
                        <div class="cell">
                            <div class="counter-value number-count" data-count="2711">1</div>
                            <p class="counter-info">Fans</p>
                        </div>
                        <div class="cell">
                            <div class="counter-value number-count" data-count="327">1</div>
                            <p class="counter-info">Shop Admirers</p>
                        </div>
                        <div class="cell">
                            <div class="counter-value number-count" data-count="221">1</div>
                            <p class="counter-info">Sales</p>
                        </div>
                        <div class="cell">
                            <div class="counter-value number-count" data-count="88">1</div>
                            <p class="counter-info">5-Star Reviews</p>
                        </div>
                    </div>
                    <!-- end of counter -->
                    
                </div> <!-- end of col -->
            </div> <!-- end of row -->
        </div> <!-- end of container -->
    </div> <!-- end of counter -->
    <!-- end of statistics -->
</template>

<script>
export default {
  name: 'StatsSection'
}
</script>


// WEBPACK FOOTER //
// src/components/StatsSection.vue